exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ui.middle.aligned.center.aligned.grid[data-v-c45a361e] {\n  height: 100vh;\n  width: 100%;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.ui.middle.aligned.center.aligned.grid > .column[data-v-c45a361e] {\n  width: 450px;\n}\n@media screen and (max-width: 768px) {\n.ui.middle.aligned.center.aligned.grid > .column[data-v-c45a361e] {\n      width: 100%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c45a361e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/auth/ForgotPassword.vue
// module id = U3SA
// module chunks = 1